import theme from './theme';

const capitalize = (str) => typeof str === 'string'
    ? `${str.charAt(0).toUpperCase()}${str.slice(1)}`
    : str;

const combineClasses = (...classObjs) => {
    return classObjs.reduce((obj, classObj = {}) => {
        Object.entries(classObj).forEach(([key, value]) => {
            if (obj[key]) {
                return obj[key] += ` ${value}`;
            }
            obj[key] = value;
        });

        return obj;
    }, {});
};

export {
    capitalize,
    combineClasses,
    theme,
};
